export const SIDEBAR_WIDTH_PROP = '--sidebar-width';
